module.exports = __webpack_public_path__ + "img/dea-formazione-ico-didattica-inclusiva.b152e856.svg";